<template>
    <div class="city">
         <!-- 头部 -->
        <div class="header">
            <div class="header-left" @click="back">
              <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
                <P>镇街定位</P>
            </div>
            <div></div>
        </div>
        <!-- 当前镇街 -->
        <div class="currentTown" @click="CurrentTownClick">
            <p v-if="currentTown">当前镇街: {{currentTown}}</p>
            <p v-else-if="ErrorText">{{ErrorText}}</p>
            <p v-else>获取位置中...</p>
        </div>
        <!-- 镇街列表 -->
        <div class="list" ref="wrapper">
            <div class="content">
                 <div class="area" v-for="(item,key) of city" :key="key">
                <div class="title">{{key}}</div>
                <div class="item-list">
                    <div class="item" v-for="innerItem of item" :key="innerItem.id" @click="CityClick(innerItem.name,innerItem.id)">{{innerItem.name}}</div>
                    
                </div>
              </div>
            </div>
           
        </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
import city from '../../assets/City/city.js'
export default {
    data() {
        return {
          city: city,
          currentTown: '',
          ErrorText:''
        }
      
    },
    created(){
        this.getCurrentTown()
    },
    mounted() {
     
    
    this.$nextTick(() => {
    if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
            click: true
        })
     }
    })
         
     

  },
  methods: {
      back () {
          this.$router.back()
      },
      getCurrentTown () {
          
                let _this = this 
                this.$axios.get('/api/DjOrder/GetJsSdk',{
                    params: {

                        "Url": location.href
                    }
                }).then(res => {
                    let data = res.data
                    //console.log(data)
                    _this.$wx.config({
                        debug: false,
                        appId: data.appId,
                        timestamp: data.timestamp,
                        nonceStr: data.nonceStr,
                        signature: data.signature,
                        jsApiList: [
                        'getLocation'
                        ]
                    });
                    _this.$wx.ready(function(){
                        _this.$wx.getLocation({
                        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                        success: function (res) {
                            console.log(res)
                            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                            var speed = res.speed; // 速度，以米/每秒计
                            var accuracy = res.accuracy; // 位置精度


                            var latlon_amap = longitude+','+latitude;
                            var url = 'https://restapi.amap.com/v3/geocode/regeo';
                    
                            _this.$jsonp(url,{
                                output:'json',
                                location: latlon_amap,
                                key:'ff66688eafa2d6d12ce99ec36f4c616d',
                                radius:500,
                                extensions: 'base'
                            }).then(res => {
                               _this.currentTown = res.regeocode.addressComponent.township+'(不在服务范围)'
                                for (var index in city){
                                    city[index].forEach(i => {
                                        if (res.regeocode.addressComponent.township == i.name) {
                                             _this.currentTown = res.regeocode.addressComponent.township
                                        }  
                                    })
                                }
                            })
                        }
                   });
                });
                    
                    
                }).catch(() => {
                    this.ErrorText = '定位失败！'
                })
               
                
                      

      },
      CityClick (name,id) {
        this.$store.dispatch('chengeTown', name)
        this.$axios.defaults.headers.common['TownStreet'] = id
        localStorage.setItem('TownStreetName', name)
        this.cookieUtil.setCookie('TownStreetName', name)
        localStorage.setItem('TownStreet', id)
        this.cookieUtil.setCookie('TownStreet', id)
        this.$router.push('/')
        
      },
      CurrentTownClick () {
         
         for (var index in city){
          city[index].forEach(i => {
              if (i.name == this.currentTown) {
                // 初始化请求头
                this.$axios.defaults.headers.common['TownStreet'] = i.id
                localStorage.setItem('TownStreet', i.id)
                this.cookieUtil.setCookie('TownStreet', i.id)
                this.$store.dispatch('chengeTown', this.currentTown)
                localStorage.setItem('TownStreetName', this.currentTown)
                this.cookieUtil.setCookie('TownStreetName', this.currentTown)
                this.$router.push('/')
              }
          })
   
         }
         
      }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.city
  background: rgb(240, 240, 240)
  height: 100%
  .header
   position: fixed
   z-index: 90
   left: 0
   right: 0
   top: 0
   display: flex
   justify-content: space-between
   width: 100%
   height: 44px
   align-items: center
   background-color: white
   font-weight: bold
   .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
   .header-center
     width: 120px
  .currentTown
   position: fixed
   top: 44px
   width: 100%
   height: 32px
   padding: 8px
   box-sizing: border-box
   background: white
   color: green
   z-index: 90
   display: flex
   align-items: center
  .list
    overflow: hidden
    position: absolute
    top: 76px
    left: 0
    right: 0
    bottom: 0
    .title
     line-height: 28px
     background: #eee
     padding-left: 10px
     color: #666
     font-size: 13px
    .item-list
     .item
       line-height: 38px
       padding-left: 10px
       background: white
       border-bottom: 1px solid #eee
</style>



// WEBPACK FOOTER //
// src/pages/City/City.vue